module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/robotnode-f1d84f06addd0f6d8ec7dbe037bbde68.svg";